import { render } from "./InvitesHistory.vue?vue&type=template&id=c1b3613e&scoped=true"
import script from "./InvitesHistory.vue?vue&type=script&lang=js"
export * from "./InvitesHistory.vue?vue&type=script&lang=js"

import "@/assets/scss/_list-history.scss?vue&type=style&index=0&id=c1b3613e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b3613e"]])

export default __exports__